export interface IDocuments {
  id: string;
  name: null | string;
  requiresConsent: boolean;
  index: number;
  hasWatermark: boolean | null;
  clientId: null | string;
  createdBy: null | string;
  createdOn: null | string;
  folders: Documents[] | null;
  publishedFiles: Files | null;
  unPublishedFiles: Files | null;
  permissions: Permission[] | null;
  root: boolean;
  isRoot: boolean;
  width?: number;
}

export enum DocumentFilter {
  Folder = "foldersVisibility",
  Name = "names",
  Fund = "funds",
  Status = "status",
  Investor = "investors",
  FileSize = "fileSizeInBytes",
  Quarter = "quarters",
  Permission = "permissions",
}

export enum DocumentTypeEnum {
  Folder = "folder",
  File = "file",
}

export type Permission = {
  name: string;
  key: string;
  description?: string;
};

export type FolderContentRequestPayload = {
  funds: string[];
  investors: string[];
  page: number;
  pageSize: number;
  quarters: string[];
  searchText: string;
  sort: string[];
  showFolders?: boolean | undefined;
};

export type Folder = {
  folders: Documents[] | null;
  hasWatermark: boolean;
  index: number;
  loaded: boolean;
  name: string;
  permissions: Permission[] | null;
  unPublishedFiles: Files | null;
  publishedFiles: Files | null;
};

export type File = {
  id: string;
  name: string;
  fileType: string;
  sizeInBytes: number;
  published: boolean;
  investor: Fund | null;
  fund: Fund;
  quarter: string;
  index: number;
  isNew?: boolean;
  isSelected?: boolean;
  folderId?: string;
  clientId?: string;
  width?: number;
};

export type FileV2 = {
  id: string;
  name: string;
  fileType: string;
  sizeInBytes: number;
  published: boolean;
  investors: Array<Fund>;
  funds: Array<Fund>;
  quarter: string;
  index: number;
  isNew?: boolean;
  isSelected?: boolean;
};

export type Fund = {
  id: string;
  name: string;
};

export type Files = {
  pageSize: number;
  totalItems: number;
  files: File[];
};

export type FilesV2 = {
  totalItems: number;
  files: FileV2[];
};

export type UploadFileResponse = {
  files: File[];
  failedFiles: Object;
};

export type FileTagParams = {
  investorId?: string;
  fundId?: string;
  quarterid?: string;
  fileIds: Array<string>;
  folderId: string;
};

export type Error = {
  id: string;
  label: string;
  errorMsg: string;
  iconType?: string;
};

export type PublishFileParams = {
  fileIds: Array<string>;
  folderId: string;
};

export enum PublishStatusEnum {
  Publish = "PUBLISH",
  Unpublish = "UNPUBLISH",
}

export type DocumentLinkParams = {
  baseDocumentUrl: string;
  ids: Array<string>;
  type: "DOCUMENT_LINK";
  clientName: string;
};

export type Documents = IDocuments;
export type DocumentType = DocumentTypeEnum;
export type DocFile = File;
export type EmailOrUrl = {
  value: string;
};
export type NoticeUrl = {
  [key: string]: string;
};

export type ConsentQueryParams = {
  clientId: string;
  consentType: string;
};

export type ConsentBodyParams = {
  folderId: string;
  response: boolean;
};